//components
import {ReactCalendar} from "thrive-components"
import CalendarButton from '../../../elements/CalendarButton/CalendarButton';
import ResetButton from  '@/components/elements/activityFeed/elements/ResetButton/ResetButton';

//hooks
import UseDateFilter from './DateFilter.hooks';



const DateFilter = () => {
    const {title, containerRef, calendarSelectedDates, calendarButtonText, calendarButtonAriaLabel, onClickCalendarButton, resetButtonText, resetButtonAriaLabel, onClickClearDates, resetIsDisabled, className, setFilterDates, scrollTargetRef} = UseDateFilter();
    
    return (
        <div className="pop-out-date-filter-wrapper">
            <div className="checkbox-list-title">{title}</div>

            <div className='pop-out-date-filter' ref={containerRef}>
                <CalendarButton 
                    content={calendarButtonText} 
                    ariaLabel={calendarButtonAriaLabel} 
                    onButtonClick={onClickCalendarButton} 
                />

                <ResetButton 
                    content={resetButtonText} 
                    ariaLabel={resetButtonAriaLabel} 
                    onButtonClick={onClickClearDates} 
                    isDisabled={resetIsDisabled}
                />
                
                <ReactCalendar 
                    className={className} 
                    selectedDates={calendarSelectedDates} 
                    setSelectedDates={setFilterDates} 
                    isSelectPastOnly 
                />

                <div ref={scrollTargetRef} />
            </div>
        </div>
    );
};
export default DateFilter